<template>
  <div
    class="working-days-group"
    :class="{ 'working-days-group--preview': hideHeader }"
  >
    <div
      v-if="!hideHeader"
      class="working-days-header"
    >
      <span>{{ title }}</span>
      <span
        v-if="revisionNote"
        class="working-days-header__revision-note"
      >
        {{ revisionNote }}
      </span>
      <YhcServiceLevelSpanPreview
        v-if="spanNote"
        :period-label="spanPeriodLabel"
      >
        <template #trigger>
          <span class="working-days-header__revision-note">{{ spanNote }}</span>
        </template>
        <slot name="spanPreview" />
      </YhcServiceLevelSpanPreview>
    </div>
    <div class="working-days-row">
      <div
        v-for="(day, index) in weekdays"
        :key="index"
        class="day-header"
      >
        {{ day }}
      </div>
    </div>
    <div class="working-days-row">
      <div
        v-for="(day, index) in weekdays"
        :key="index"
        class="day-value"
        :class="{
          working: isWorkingDay(day, regularWorkingDays),
          'non-working': !isWorkingDay(day, regularWorkingDays),
        }"
      >
        {{ getWorkingDayDisplay(day, regularWorkingDays) }}
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'
import { ModelYhcRegularWorkingDays } from '../../../../models/fireModels/yhcDataTypes'
import YhcServiceLevelSpanPreview from './YhcServiceLevelSpanPreview.vue'

export default defineComponent({
  name: 'YhcServiceLevelDaysSlot',
  components: {
    YhcServiceLevelSpanPreview,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    hideHeader: {
      type: Boolean,
      default: false,
    },
    spanNote: {
      type: String,
      default: '',
    },
    spanPeriodLabel: {
      type: String,
      default: '',
    },
    regularWorkingDays: {
      type: Object as PropType<ModelYhcRegularWorkingDays | null>,
      default: null,
    },
    revisionNote: {
      type: String,
      default: '',
    },
  },
  computed: {
    weekdays(): string[] {
      return ['月', '火', '水', '木', '金', '土', '日']
    },
  },
  methods: {
    isWorkingDay(
      dayOfWeek: string,
      regularWorkingDays: ModelYhcRegularWorkingDays | null,
    ): boolean {
      if (!regularWorkingDays || regularWorkingDays.regular_weekdays?.length === 7) {
        return true
      }
      return regularWorkingDays.regular_weekdays?.includes(dayOfWeek) || false
    },
    getWorkingDayDisplay(
      dayOfWeek: string,
      regularWorkingDays: ModelYhcRegularWorkingDays | null,
    ): string {
      return this.isWorkingDay(dayOfWeek, regularWorkingDays) ? '〇' : '休'
    },
  },
})
</script>

<style>
.working-days-group {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 1rem;
}

.working-days-header {
  font-weight: bold;
  margin-bottom: 0.3rem;
  text-align: left;
  color: var(--yhc-color, #1a73e8);
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 0.35rem;
}

.working-days-header__revision-note {
  font-weight: 600;
  font-size: 0.75rem;
  color: #dc3545;
  line-height: 1.3;
}

.working-days-row {
  display: flex;
  width: 100%;
}

.day-header {
  flex: 1;
  text-align: center;
  font-size: 0.875rem;
  padding: 0.2rem 0;
  font-weight: bold;
  margin: 0 0.15rem;
}

.day-value {
  flex: 1;
  text-align: center;
  font-size: 0.875rem;
  padding: 0.3rem 0;
  border: 1px solid #e0e0e0;
  margin: 0.15rem;
  border-radius: 6px;
  width: 2.4rem;
}

.day-value.working {
  color: #0066cc;
  background-color: #f0f7ff;
}

.day-value.non-working {
  color: #dc3545;
  background-color: #fff0f0;
}
</style>
